export default __webpack_public_path__ + "static/media/img-slider-cmbus-5.27b43fb6.png";